/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { Dropdown, isEmptyValue, TextboxInput, TextInput } from '@blend/enterprise-components';
import { WrappedInput } from 'blb-components/WrappedInput';
export const lienTypeConfigs = [{
  disabled: false,
  text: 'Mortgage',
  value: 'MORTGAGE'
}, {
  disabled: false,
  text: 'Lien',
  value: 'LIEN'
}, {
  disabled: false,
  text: 'Judgment',
  value: 'JUDGMENT'
}, {
  disabled: false,
  text: 'Solar Lien',
  value: 'SOLAR_LIEN'
}, {
  disabled: false,
  text: 'UCC Solar Lien',
  value: 'UCC_SOLAR_LIEN'
}, {
  disabled: false,
  text: 'PACE Lien',
  value: 'PACE_LIEN'
}];
export const lienStatusConfigs = [{
  disabled: false,
  text: 'Opened',
  value: 'OPENED'
}, {
  disabled: false,
  text: 'Cleared',
  value: 'CLEARED'
}, {
  disabled: false,
  text: 'Cleared - Paid at closing',
  value: 'PAID_AT_CLOSING'
}, {
  disabled: false,
  text: 'Cleared - Paid prior to closing',
  value: 'PAID_PRIOR_TO_CLOSING'
}, {
  disabled: false,
  text: 'Subordinated at closing',
  value: 'SUBORDINATED'
}];
export const taxStatusConfigs = [{
  disabled: false,
  text: 'Due',
  value: 'DUE'
}, {
  disabled: false,
  text: 'Delinquent',
  value: 'DELINQUENT'
}, {
  disabled: false,
  text: 'Paid',
  value: 'PAID'
}, {
  disabled: false,
  text: 'Paid at closing',
  value: 'PAID_AT_CLOSING'
}];
export const requirementStatusConfigs = [{
  disabled: false,
  text: 'Opened',
  value: 'OPENED'
}, {
  disabled: false,
  text: 'Cleared',
  value: 'CLEARED'
}, {
  disabled: false,
  text: 'Cleared at closing',
  value: 'CLEARED_AT_CLOSING'
}];
export const policyAmountInputConfig = {
  component: WrappedInput,
  customComponentProps: {
    type: 'moneyCents'
  },
  hideLabel: true,
  inputComponent: TextInput,
  label: 'Title Policy Amount',
  name: 'policyAmount'
};
export const vestingInputConfig = {
  component: WrappedInput,
  customComponentProps: {
    type: 'text'
  },
  hideLabel: true,
  inputComponent: TextInput,
  label: 'Title Vesting',
  name: 'vesting'
};
export const legalDescriptionInputConfig = {
  component: WrappedInput,
  customComponentProps: {
    type: 'text'
  },
  hideLabel: true,
  inputComponent: TextboxInput,
  label: 'Legal Description',
  name: 'legalDescription'
};
export const creditorNameInputConfig = {
  component: WrappedInput,
  customComponentProps: {
    type: 'text'
  },
  hideLabel: true,
  inputComponent: TextInput,
  label: 'Creditor Name',
  name: 'creditorName',
  validate: isEmptyValue('Creditor name is missing')
};
export const lienTypeInputConfig = {
  component: WrappedInput,
  customComponentProps: {
    options: lienTypeConfigs
  },
  hideLabel: true,
  inputComponent: Dropdown,
  label: 'Type',
  name: 'type',
  validate: isEmptyValue('Please select an option')
};
export const lienAmountInputConfig = {
  component: WrappedInput,
  customComponentProps: {
    type: 'moneyCents'
  },
  hideLabel: true,
  inputComponent: TextInput,
  label: 'Amount',
  name: 'amount',
  validate: isEmptyValue('Amount is missing')
};
export const lienStatusInputConfig = {
  component: WrappedInput,
  customComponentProps: {
    options: lienStatusConfigs
  },
  hideLabel: true,
  inputComponent: Dropdown,
  label: 'Status',
  name: 'status',
  validate: isEmptyValue('Please select an option')
};
export const docInputConfig = {
  component: WrappedInput,
  customComponentProps: {
    type: 'text'
  },
  hideLabel: true,
  inputComponent: TextInput,
  label: '',
  name: 'docId'
};
export const taxNameInputConfig = {
  component: WrappedInput,
  customComponentProps: {
    type: 'text'
  },
  hideLabel: true,
  inputComponent: TextInput,
  label: 'Tax Name',
  name: 'taxName',
  validate: isEmptyValue('Tax name is missing')
};
export const taxDueDateInputConfig = {
  component: WrappedInput,
  customComponentProps: {
    type: 'date'
  },
  hideLabel: true,
  inputComponent: TextInput,
  label: 'Due Date',
  name: 'dueDate',
  validate: isEmptyValue('Due date is missing')
};
export const taxAmountInputConfig = {
  component: WrappedInput,
  customComponentProps: {
    type: 'moneyCents'
  },
  hideLabel: true,
  inputComponent: TextInput,
  label: 'Amount',
  name: 'amount',
  validate: isEmptyValue('Amount is missing')
};
export const taxStatusInputConfig = {
  component: WrappedInput,
  customComponentProps: {
    options: taxStatusConfigs
  },
  hideLabel: true,
  inputComponent: Dropdown,
  label: 'Status',
  name: 'status',
  validate: isEmptyValue('Please select an option')
};
export const requirementDescriptionInputConfig = {
  component: WrappedInput,
  customComponentProps: {
    type: 'text'
  },
  hideLabel: true,
  inputComponent: TextInput,
  label: 'Description',
  name: 'description',
  validate: isEmptyValue('Description is missing')
};
export const requirementStatusInputConfig = {
  component: WrappedInput,
  customComponentProps: {
    options: requirementStatusConfigs
  },
  hideLabel: true,
  inputComponent: Dropdown,
  label: 'Status',
  name: 'status',
  validate: isEmptyValue('Please select an option')
};